import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { RecoilRoot } from 'recoil'
import PageNotFound from '../../util/page/PageNotFound'
import AccountsList from './page/AccountsList'


function AccountsMain() {
  return (
    <Routes>
        <Route path="/list" element={
            <RecoilRoot key='accounts'>
                <AccountsList/>
            </RecoilRoot>
        }/>
        <Route path="*" element={<PageNotFound/>}/>
    </Routes>
    
  )
}

export default AccountsMain